/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_029: Question = {
  id: 'pres-029-liste-especes-statut',
  oldId: '43',
  title: 'La liste des espèces à statut présente sur le territoire est connue',
  number: '3.13',
  description: ['donnée obtenue par le géomaticien du programme'],
  type: QuestionType.ACTIVITY,
  frequency: 3,
  doneByRE: true,
  slots: [
    {
      type: SlotTypes.GEOMATIQUE,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data: string[]) => data,
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.NUMBER_OF,
    },
  ],
};

const question_pres_029__v3: Question = {
  ...question_pres_029,
  frequency: 2,
  number: '3.4',
};

export const question_pres_029_v2: Question = question_pres_029;
export const question_pres_029_v3: Question = question_pres_029__v3;
